import axios from "../axios";
import AxiosConfig from "../AxiosConfig";

/**
 *
 * @returns {function(*): Promise<AxiosResponse<T> | never>}
 */
export const fetchModules = () => {

  return dispatch => {

    dispatch({type: "MODULES_FETCH"});

    const url = AxiosConfig.getEndpointAddress() + (
      AxiosConfig.getAuthToken() ? "/modules" : "/public/modules"
    );

    return axios.get(
      url,
      AxiosConfig.getAuthToken() ? AxiosConfig.getAuthConfig() : AxiosConfig.getConfig(),
    )
      .then((response) => {

        dispatch({
          type: "MODULES_FETCH_FULFILLED",
          data: response.data,
        });

      })
      .catch(function (error) {

        dispatch({
          type: "MODULES_FETCH_REJECTED",
          data: error,
        });

      });
  };
};

/**
 *
 * @returns {Function}
 */
export const masterCertificatePDF = () => {

  return async dispatch => {

    dispatch({type: "MASTER_CERTIFICATE_PDF"});

    const url = AxiosConfig.getEndpointAddress() + '/mastercertificate';

    await axios.get(
      url,
      {
        ...AxiosConfig.getAuthConfig(),
        responseType: 'blob',
      },
    )
      .then((response) => {

        const blob = new Blob([response.data], {type: 'application/pdf'});
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', 'MLMMasterCertificate.pdf');
        document.body.appendChild(link);
        link.click();

        dispatch({type: "MASTER_CERTIFICATE_PDF_FULFILLED"});

      })
      .catch(function (error) {

        dispatch({type: "MASTER_CERTIFICATE_PDF_REJECTED", data: error});

      });
  }
};
